import { useContext } from 'react';
import CurrentBuilderPageContext from '../contexts/CurrentBuilderPageContext';

const useCurrentBuilderPage = () => (
  useContext(CurrentBuilderPageContext)
);

export default useCurrentBuilderPage;
